import * as Schema from 'generated/graphql/schema';
import * as React from 'react';

// FIXME: Rephrase deviceType - it's confusing! Given that index is specified,
// this context actually refers to a peripheral - not a device! Thus, deviceType
// should ideally be peripheralType, where, if that type is equal 'SENSOR'
// enables sensorType that is currently defined as deviceType below. Proposal:
// Split this context into a (1) device, (2) peripheral, (3) sensor and (4)
// camera.

export interface Properties {
  owner?: string;
  uuid: string;
  index: string;
  deviceType?:
    | 'COUNTER'
    | 'COUNTER_ACCUMULATE'
    | 'COUNTER_SPEED'
    | 'DISCRETE'
    | 'EVENT'
    | 'MEASUREMENT'
    | 'MANUAL_PROCESS';
  NodePicker?: any;
  lineNodes: Schema.LineSimpleQuery['line']['nodes'];
  deviceLineId?: string;
}

export const DeviceContext = React.createContext<Properties>({
  owner: undefined,
  uuid: '',
  index: '0',
  deviceType: 'COUNTER',
  NodePicker: undefined,
  lineNodes: [],
  deviceLineId: undefined,
});
